// extracted by mini-css-extract-plugin
module.exports = {"widgetItem":"WidgetItem_widgetItem__3Vw0z","title":"WidgetItem_title__10rKp","lastItem":"WidgetItem_lastItem__Er5fM"};